<template>
  <s-wrapper>

    <c회원선택 ref="selectCust" @select="sCust = $event" />

    <i-btn @click="$refs.selectCust.open()">회원선택</i-btn>

    <div v-if="sCust">
      선택된 회원 : {{ sCust }}
    </div>

    <hr>
    <br/>
    <br/>
    <br/>

    <c회원선택2 ref="selectCust2" @select="sCust2 = $event" />

    <i-btn @click="$refs.selectCust2.open()">회원선택2</i-btn>

    <div v-if="sCust2">
      선택된 회원 : {{ sCust2 }}
    </div>

  </s-wrapper>
</template>


<script>
export default {
  components: {
    "c회원선택" : require('@/components/c회원선택.vue').default,
    "c회원선택2" : require('@/components/c회원선택2.vue').default,
  },
  data () {
    return {
      sCust : null,
      sCust2 : null,
    }
  },
}
</script>